var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "left_item" }, [
      _c("div", { staticClass: "titleOne titleTwo" }, [_vm._v("目的地：")]),
      _c("div", { staticClass: "contentTwo" }, [
        _c("span", [_vm._v(_vm._s(_vm.item.destination))]),
      ]),
    ]),
    _c("div", { staticClass: "left_item" }, [
      _c("div", { staticClass: "titleOne titleTwo" }, [
        _vm._v("预估出行日期："),
      ]),
      _c("div", { staticClass: "contentTwo" }, [
        _c("span", [_vm._v(_vm._s(_vm.item.travelDate))]),
      ]),
    ]),
    _c("div", { staticClass: "left_item" }, [
      _c("div", { staticClass: "titleOne titleTwo" }, [
        _vm._v("预估出行人数："),
      ]),
      _c("div", { staticClass: "contentTwo" }, [
        _c("span", [_vm._v(_vm._s(_vm.item.travelNumber))]),
        _c("span", { staticClass: "Icon" }, [
          _vm._v(_vm._s(_vm.item.travelType == 1 ? "私家团" : "企业团")),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "left_item" }, [
      _c("div", { staticClass: "titleOne titleTwo" }, [
        _vm._v("预估所需项目："),
      ]),
      _c("div", { staticClass: "contentTwo" }, [
        _c("span", [_vm._v(_vm._s(_vm.item.containProject) + " ")]),
      ]),
    ]),
    _c("div", { staticClass: "left_item" }, [
      _c("div", { staticClass: "titleOne titleTwo" }, [_vm._v("期待及主题：")]),
      _c(
        "div",
        { staticClass: "contentTwo" },
        _vm._l(_vm.item.theme, function (item1, index1) {
          return _c("span", { key: index1 }, [_vm._v(_vm._s(item1) + " ")])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }